import React from 'react';
import classNames from 'classnames';
import { Icon } from '../../icons/Icon';
import { IconNames } from '../../icons/Icons';
import { Button, ButtonProps } from '../button/Button';
import styles from './ButtonWithIcon.module.scss';

export const ButtonWithIcon = ({ icon, children, position = 'left', strokeWidth, ...rest }: Props) => (
    <Button {...rest}>
        {position === 'left' && <Icon size='small' type={icon} strokeWidth={strokeWidth} className={classes(position)} />}
        {children}
        {position === 'right' && <Icon size='small' type={icon} strokeWidth={strokeWidth} className={classes(position)} />}
    </Button>
);

const classes = (position: 'left' | 'right') => classNames({
    [styles.left]: position === 'left',
    [styles.right]: position === 'right'
});

type Props = ButtonProps & {
    icon: IconNames;
    position?: 'left' | 'right';
    strokeWidth?: number;
};